import { render, staticRenderFns } from "./linkComponent.vue?vue&type=template&id=1c8e884e&scoped=true&"
import script from "./linkComponent.vue?vue&type=script&lang=js&"
export * from "./linkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e884e",
  null
  
)

export default component.exports